// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f7d9a39","239":"c82a189a","453":"169795a6","455":"0f348e2a"}[chunkId] + ".chunk.js";
};